export const pad = padding => (num, digits) => {
  if (num.toString().length < digits) {
    return pad(padding)(`${padding}${num}`, digits)
  }

  return num.toString()
}

export const zeroPad = pad('0')
